import './styles.scss';
import { useTranslation } from 'react-i18next';
import { Handle, Position } from '@xyflow/react';
import { IconTrash } from '@tabler/icons-react';
import { Text } from '@fragments';

export default function StepNode({ data }) {
    const { t } = useTranslation('formsModals');

    return (
        <div className={`step-node${data.isSelected ? ' step-node--selected' : ''}`}>
            <Handle
                type="target"
                position={Position.Top}
                style={{ background: 'var(--surface-6)', width: 8, height: 8 }}
            />

            <div className="step-node-header">
                <span className="step-number-badge">{data.stepNumber}</span>
                <Text.span contrast={8} className="step-label">{data.title}</Text.span>
                <button
                    className="step-delete-btn"
                    data-action="delete"
                    title={t('builder.canvas.deleteStepTitle')}
                >
                    <IconTrash size={13} />
                </button>
            </div>

            <div className="step-node-body">
                <Text.span contrast={4}>
                    {data.questions?.length > 0
                        ? t('builder.canvas.questionCount', { count: data.questions.length })
                        : t('builder.canvas.noQuestions')}
                </Text.span>
            </div>

            <Handle
                type="source"
                position={Position.Bottom}
                style={{ background: 'var(--surface-6)', width: 8, height: 8 }}
            />
        </div>
    );
}
